angular.module('skeyenoteWebApp').service('noteRenameService', NoteRenameService);

function NoteRenameService($rootScope) {
  'ngInject';

  let self = this;

  /**
   * <options schema>
   * title: string - Modal title
   * oldName: string - name to initialize input
   * callback: (newName: string)=>void - callback onButtonClick
   * validator: (str: string)=>boolean - input validator
   */
  self.openRenameModal = function(options) {
    $rootScope.$broadcast('openRenameModal', options);
  };
}
